module.exports = __webpack_public_path__ + "static/avalanche-50b0e703d7beeefe59dccf968ed6690a.jpg";